import React, { useEffect, useState } from "react";
import { StyleSheet, TextInput, Platform } from "react-native";
import { isWeb, useDebounce } from "../../../helpers/utils";

import AppConfig from "../../../config/AppConfig";
import AppTheme from "../AppTheme";

const ManaTextInput = React.forwardRef((props, ref) => {
  const {
    value = "",
    placeholder = "Search Activities & Tags",
    placeholderTextColor = "9C9EB9",
    onTextChanged = () => {},
    contentHeight = 50,
    keyboardType = "default",
    maxLength = 100000,
    textContentType = "none",
    debounceDelay = 1500,
    disableBorder = false,
  } = props;
  const [updatedText, setUpdatedText] = useState(value);
  const [height, setHeight] = useState(contentHeight);
  const [userHasTyped, setUserHasTyped] = useState(false);
  const debouncedSearchTerm = useDebounce(updatedText, debounceDelay);
  const [borderStyle, setBorderStyle] = useState({});

  useEffect(() => {
    setUpdatedText(value);
  }, [value]);

  useEffect(() => {
    if (userHasTyped) onTextChanged(updatedText);
  }, [debouncedSearchTerm]);

  const updateTextValue = (text) => {
    setUserHasTyped(true);
    setUpdatedText(text);
  };

  const updateContentHeight = (e) => {
    setHeight(Math.max(50, e.nativeEvent.contentSize.height));
  };

  const onBlur = () => {
    setBorderStyle({});
  };

  const onFocus = () => {
    if (!props.hideOutline) {
      setBorderStyle({
        borderWidth: 1,
        borderStyle: "dotted",
        borderColor: AppTheme.DEFAULT_COLOR,
      });
    }
  };

  return (
    <TextInput
      ref={ref}
      editable={!props.readOnly}
      keyboardType={keyboardType}
      maxLength={maxLength}
      textContentType={textContentType}
      style={[
        styles.input,
        styles.inputPlatform,
        props.style,
        { height: height },
        !disableBorder && borderStyle,
      ]}
      autoFocus={props.autoFocus ? !!props.autoFocus : isWeb}
      onChangeText={(text) => updateTextValue(text)}
      placeholder={placeholder || ""}
      placeholderTextColor={placeholderTextColor}
      multiline={props.multiline}
      numberOfLines={props.numberOfLines}
      value={updatedText || ""}
      onContentSizeChange={(e) => updateContentHeight(e)}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );
});

export default ManaTextInput;

const styles = StyleSheet.create({
  input: {
    width: "100%",
    marginBottom: 10,
    paddingHorizontal: 15,
    borderRadius: 4,
    fontSize: 16,
    letterSpacing: 0.2,
    color: AppConfig.INPUT_COLOR,
    shadowOffset: { height: 1, width: 0 },
    shadowRadius: 5,
    elevation: 3,
    shadowOpacity: 0.9,
    shadowColor: "rgba(112, 136, 210, 0.4)",
    backgroundColor: "#FFF",
  },
  inputPlatform: Platform.select({
    android: {
      paddingBottom: 6,
    },
  }),
});
